module.exports = __webpack_public_path__ + "static/media/HomePic10.5fa56e08.jfif";